import { IFieldServer } from "@common/redux/forms/interface";
export const mobileNumberDefaultValue: IFieldServer = {
  fieldType: "NUMBER_INPUT",
  title: "Mobile number",
  isVisible: true,
  isDisabled: false,
  isRequired: false,
  grid: {
    width: 6,
  },
  canDelete: true,
  canCopy: true,
  canAdd: true,
  type: "TEXT_INPUT",
  name: "Mobile number",
  // localId: null,
  rules: [
    {
      rule: "PHONE_NUMBER",
      errorMessage: "Enter a Valid Phone Number",
    },
  ],
  fields: [],
  fieldConfig: {
    placeHolder: "Enter Mobile Number",
    isDuplicateAllowed: true,
    isPII: false,
    isQrCodeAllowed: false,
  },
};
